import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const myaccountPageContext = React.createContext({});
export let myaccountPageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMMyAccountPage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  myaccountPageMachine = createMachine(_machineConfig, { services, actions });
  const [state, send] = useMachine(myaccountPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    myaccountPageMachine,
    myaccountPageState: state,
    myaccountPageSend: send,
  };
};
